import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

/**
 * Replaces all <a href="..."> links in an HTML string with the result of getNonUmbracoUrl for each href.
 * @param html The HTML string to process
 * @returns The HTML string with updated <a> hrefs
 */
export function replaceRichTextLinks(html: string | null | undefined): string {
  // Handle non-string inputs gracefully
  if (!html || typeof html !== "string") {
    return ""
  }

  return html.replace(
    /<a\s+([^>]*href=["'])([^"'>]+)(["'][^>]*)>/gi,
    (match, beforeHref, href, afterHref) => {
      const newHref = getNonUmbracoUrl(href)
      return `<a ${beforeHref}${newHref}${afterHref}>`
    },
  )
}
